export interface BaseResponse<T> {
  status: number;
  message: string;
  data: T;
}

export interface TableList<T> {
  data: { total: number; currentPage: number; pageSize: number; records: unknown[]; } | PromiseLike<{ total: number; currentPage: number; pageSize: number; records: unknown[]; }>;
  total: number;
  currentPage: number;
  pageSize: number;
  records: T[];
}

export const FORMAT_TIME = 'YYYY-MM-DD HH:mm:ss';

export const FORMAT_DATE = 'YYYY-MM-DD';
